import { render, staticRenderFns } from "./AssignedInstructors.vue?vue&type=template&id=11ad0bee&scoped=true"
import script from "./AssignedInstructors.vue?vue&type=script&lang=js"
export * from "./AssignedInstructors.vue?vue&type=script&lang=js"
import style0 from "./AssignedInstructors.vue?vue&type=style&index=0&id=11ad0bee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ad0bee",
  null
  
)

export default component.exports